export const CONTRACTION_FIELD_KEYS = {
  COMPANY_NAME: 'companyName',
  COMPANY_ADDRESS: 'companyAddress',
  TAX_CODE: 'taxCode',
  EMAIL: 'companyEmail',
  PHONE: 'companyPhone',
  FAX: 'fax',
  REPRESENTATIVE: 'representative',
  JOB_TITLE: 'title',
  OTHER_CONTACT_DETAILS: 'otherContactDetails',
}

export const IS_VALID_FIELDS = Object.assign(
  {},
  ...Object.keys(CONTRACTION_FIELD_KEYS).map((item) => ({ [item]: true })),
)

export const ALL_CONTRACTION_FIELDS = [
  {
    key: CONTRACTION_FIELD_KEYS.COMPANY_NAME,
    title: 'userManagement.quotationInfo.COMPANY_NAME',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.COMPANY_ADDRESS,
    title: 'userManagement.quotationInfo.COMPANY_ADDRESS',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.TAX_CODE,
    title: 'userManagement.quotationInfo.TAX_CODE',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.EMAIL,
    title: 'userManagement.quotationInfo.EMAIL',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.PHONE,
    title: 'userManagement.quotationInfo.PHONE',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.FAX,
    title: 'userManagement.contractInfo.FAX',
    value: '',
    isRequired: false,
  },
  {
    key: CONTRACTION_FIELD_KEYS.REPRESENTATIVE,
    title: 'userManagement.contractInfo.REPRESENTATIVE',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.JOB_TITLE,
    title: 'userManagement.quotationInfo.JOB_TITLE',
    value: '',
    isRequired: true,
  },
  {
    key: CONTRACTION_FIELD_KEYS.OTHER_CONTACT_DETAILS,
    title: 'userManagement.contractInfo.OTHER_CONTACT_DETAILS',
    value: '',
    isRequired: false,
  },
]
